import type AppUserDTO from '../dtos/app-user.dto'
import type AppUser from '../models/app-user.model'

export function mapAppUserFromAppUserDTO(dto: AppUserDTO): AppUser {
  return {
    id: dto.id,
    firstName: dto.first_name,
    lastName: dto.last_name,
    staffCode: dto.staff_code,
    email: dto.email,
    phoneNumber: dto.phone_number,
    role: dto.role,
  } as AppUser
}
